import * as React from 'react';
import { memo } from 'react';

const SvgQuestion = (props) => (React.createElement("svg", Object.assign({ width: "1em", height: "1em", viewBox: "0 0 20 20", fill: "none", xmlns: "http://www.w3.org/2000/svg" }, props),
    React.createElement("path", { d: "M9.85 16.959a7.2 7.2 0 1 0 0-14.4 7.2 7.2 0 0 0 0 14.4Z", stroke: "#4A4960", strokeWidth: 1.5, strokeLinecap: "round", strokeLinejoin: "round" }),
    React.createElement("path", { d: "M10 13.659a.15.15 0 1 1-.3 0 .15.15 0 0 1 .3 0Z", fill: "currentColor", stroke: "#4A4960", strokeWidth: 1.5 }),
    React.createElement("path", { d: "M9.85 10.959v-.6a2.1 2.1 0 1 0-2.1-2.1", stroke: "#4A4960", strokeWidth: 1.5, strokeLinecap: "round", strokeLinejoin: "round" })));
const Memo = memo(SvgQuestion);

export { Memo as default };
